import './style.css'; 


jQuery(document).ready(function ($) {
    // Define the prices for each service and their respective durations
    const prices = {
        "back-shoulders-neck-and-head-massage": { "30": 30, "60": 50, "90": 75, "120": 95 },
        "aromatherapy-oil-massages": { "60": 50, "90": 75, "120": 95 },
        "thai-herbal-hot-compress-massage": { "60": 60, "90": 90, "120": 115 },
        "deep-tissue-massage": { "60": 50, "90": 75, "120": 95 },
        "traditional-thai-foot-massage": { "60": 50, "90": 75, "120": 95 },
        "traditional-thai-massage": { "60": 55, "90": 80, "120": 100 },
        "trapped-nerve-&-body-fixing": { "60": 60, "90": 90, "120": 115 },
    };

    // Cache jQuery selectors for form elements
    const $serviceSelect = $("#service");
    const $durationSelect = $("#duration");
    const $priceDisplay = $("#price");
    const $dateInput = $("#date");
    const $timeInput = $("#time");
    const $bookingForm = $("#booking-form");
    const $submitButton = $bookingForm.find("button[type='submit']");

    // Function to update the duration options based on the selected service
    function updateDurationOptions() {
        const service = $serviceSelect.val(); // Get the selected service
        const availableDurations = prices[service] ? Object.keys(prices[service]) : []; // Get available durations for the service

        $durationSelect.empty(); // Clear existing options

        // Add new options for each available duration
        availableDurations.forEach((duration) => {
            $durationSelect.append(
                $("<option>", { value: duration, text: `${duration} minutes` })
            );
        });

        updatePrice(); // Update the price when the duration changes
    }

    // Function to update the price based on the selected service and duration
    function updatePrice() {
        const service = $serviceSelect.val(); // Get the selected service
        const duration = $durationSelect.val(); // Get the selected duration

        // If the service and duration are valid, update the price
        if (prices[service] && prices[service][duration]) {
            const priceValue = prices[service][duration];
            $priceDisplay.text(`£${priceValue}`); // Display the price
            $("#hidden-price").val(priceValue); // Update the hidden input field with the price
        } else {
            // If no valid service or duration, set the price to £0
            $priceDisplay.text("£0");
            $("#hidden-price").val(0);
        }
    }

    // Function to disable Sundays in the date picker
    function disableSundays() {
        const selectedDate = new Date($dateInput.val()); // Get the selected date
        const dayOfWeek = selectedDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

        // If the selected day is Sunday, show a warning and clear the date field
        if (dayOfWeek === 0) {
            Swal.fire({
                icon: "info",
                title: "Info",
                text: "Sundays are not available for bookings. Please select another day.",
            });
            $dateInput.val(""); // Clear the date input
        }
    }

    // Function to validate the selected time
    function validateTime() {
        const selectedTime = $timeInput.val(); // Get the selected time
        const minTime = "10:00"; // Minimum allowed time
        const maxTime = "17:00"; // Maximum allowed time

        // If the selected time is outside the allowed range, show a warning and clear the time field
        if (selectedTime < minTime || selectedTime > maxTime) {
            Swal.fire({
                icon: "info",
                title: "Info",
                text: "Appointments are only available between 10:00 AM and 5:00 PM.",
            });
            $timeInput.val(""); // Clear the time input
        }
    }

    // Handle form submission using AJAX
    $bookingForm.on("submit", function (e) {
        e.preventDefault(); // Prevent the default form submission

        // Disable the submit button to prevent multiple clicks
        $submitButton.prop("disabled", true);
        $submitButton.text("Processing..."); // Change the button text
        $submitButton.addClass("opacity-50 cursor-not-allowed"); // Add loading styles

        // Validate the selected date and time before proceeding
        const selectedDate = new Date($dateInput.val());
        const dayOfWeek = selectedDate.getDay();
        const selectedTime = $timeInput.val();
        const minTime = "10:00";
        const maxTime = "17:00";

        // If the selected day is Sunday, show a warning and re-enable the button
        if (dayOfWeek === 0) {
            Swal.fire({
                icon: "info",
                title: "Sorry",
                text: "Sundays are not available for bookings. Please select another day.",
            });
            $submitButton.prop("disabled", false); // Re-enable the button
            $submitButton.text("Submit"); // Restore the button text
            $submitButton.removeClass("opacity-50 cursor-not-allowed"); // Remove loading styles
            return;
        }

        // If the selected time is outside the allowed range, show a warning and re-enable the button
        if (selectedTime < minTime || selectedTime > maxTime) {
            Swal.fire({
                icon: "info",
                title: "Sorry",
                text: "Appointments are only available between 10:00 AM and 5:00 PM.",
            });
            $submitButton.prop("disabled", false); // Re-enable the button
            $submitButton.text("Submit"); // Restore the button text
            $submitButton.removeClass("opacity-50 cursor-not-allowed"); // Remove loading styles
            return;
        }

        // Prepare the form data for submission
        const formData = {
            name: $("#name").val(),
            email: $("#email").val(),
            phone: $("#phone").val(),
            date: $("#date").val(),
            time: $("#time").val(),
            service: $("#service").val(),
            duration: $("#duration").val(),
            price: $("#hidden-price").val(),
        };

        // Send the form data to the server using AJAX
        $.ajax({
            url: "/wp-json/booking/v1/process-booking", // REST API endpoint
            type: "POST",
            data: JSON.stringify(formData), // Convert data to JSON
            contentType: "application/json",
            headers: {
                "X-WP-Nonce": bookingData.nonce // Include the nonce for security
            },
            success: function (response) {
                // If the server returns a success message, show a success notification
                if (response.message) {
                    Swal.fire({
                        icon: "success",
                        title: "Success!",
                        text: response.message,
                    });

                    // Reset the form (optional)
                    $bookingForm.trigger("reset");
                } else {
                    // If no message is returned, show an error notification
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "There was a problem processing your request.",
                    });
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // If the AJAX request fails, show an error notification
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "There was a problem processing your request.",
                });
            },
            complete: function () {
                // Re-enable the submit button and restore its original text and styles
                $submitButton.prop("disabled", false);
                $submitButton.text("Submit");
                $submitButton.removeClass("opacity-50 cursor-not-allowed");
            }
        });
    });

    // Event listeners
    $serviceSelect.on("change", updateDurationOptions); // Update durations when the service changes
    $durationSelect.on("change", updatePrice); // Update the price when the duration changes
    $dateInput.on("change", disableSundays); // Disable Sundays when the date changes
    $timeInput.on("change", validateTime); // Validate the time when it changes

    // Initialize the form by updating the duration options
    updateDurationOptions();
});